import { ampli } from '@/ampli';
import type { Row, Table } from '@tanstack/react-table';

import { isTriggerOrderEligibleToken } from '@/components/TriggerOrders/utils';

import { linkStyles } from '@/styles/links';

import { Tooltip } from '@/ui/Tooltip';

import { isChainAddress } from '@/utils/models';

import type { PortfolioRow, PortfolioTableMeta } from '../types';

type PortfolioActionsCellProps = {
  row: Row<PortfolioRow>;
  table: Table<PortfolioRow>;
};

export function PortfolioActionsCell({ row, table }: PortfolioActionsCellProps) {
  const { group, token } = row.original;
  const { balanceFormatted, tokenAddress } = token;
  const meta = (table.options.meta as { portfolioMeta: PortfolioTableMeta }).portfolioMeta;
  const referencePriceUsd =
    token.priceUsd !== undefined && Number.isFinite(token.priceUsd) && token.priceUsd > 0
      ? token.priceUsd
      : undefined;

  if (
    group ||
    meta.isWatchOnly ||
    !isChainAddress(tokenAddress) ||
    !isTriggerOrderEligibleToken(tokenAddress, token.chainId) ||
    !balanceFormatted ||
    parseFloat(balanceFormatted) <= 0
  ) {
    return null;
  }

  const button = (
    <button
      className={linkStyles({ color: 'purple', underline: true, font: 'LABEL_MD' })}
      disabled={referencePriceUsd === undefined}
      onClick={() => {
        if (referencePriceUsd === undefined) return;
        ampli.addTpSlClicked({ ui_location: 'portfolio' });
        meta.onAddTriggerOrders({
          token: {
            ...token,
            tokenAddress,
            balanceFormatted,
          },
          referencePriceUsd,
        });
      }}
      type="button"
    >
      Add TP/SL
    </button>
  );

  if (referencePriceUsd !== undefined) return button;

  return (
    <Tooltip.Provider>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <span className="inline-flex">{button}</span>
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content side="top" sideOffset={8}>
            No current price available
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}
